import { Component, OnInit } from '@angular/core';
import {
  ActivatedRoute,
  Event,
  NavigationStart,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { LoadingGlobalService } from './shared/components';
import { GlobalsService } from './shared/services';
import { ToolsService } from './shared/services/tools.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'Toolbox AM';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private globals: GlobalsService,
    private loadingService: LoadingGlobalService,
    private toolService: ToolsService,
    private translate: TranslateService
  ) {
    const navStartEvents$: Observable<NavigationStart> = this.router.events.pipe(
      filter((evt: Event) => evt instanceof NavigationStart),
      map((evt: Event) => evt as NavigationStart)
    );

    navStartEvents$.subscribe((evt: NavigationStart) => {
      window.scroll(0, 0);
      this.setTool(evt.url.split('/')[evt.url.split('/').length - 1]);
    });
  }

  ngOnInit(): void {
    this.translate.setDefaultLang('es');
    this.loadingService.show();
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.code) {
        const convert = decodeURIComponent(escape(window.atob(params.code)));
        const data = JSON.parse(convert);
        this.globals.setDataFirst({
          user: data.user,
          organization: data.organization,
        });
        sessionStorage.setItem('activeUser', JSON.stringify(data.user));
        sessionStorage.setItem(
          'organization',
          JSON.stringify(data.organization)
        );
        this.globals.setUser(data.user);
        this.globals.setOrg(data.organization);
        if (params.share) {
          sessionStorage.setItem('share', params.share);
          this.router.navigate([`/ham/${params.method}`]);
          return;
        }
        this.router.navigate(['/ham']);
      }
    });
  }

  setTool(url: string): void {
    if (url.length < 50) {
      this.toolService.setActivedTool(url);
    }
  }
}
